import { changed, noOp, rejected, type Command, type CommandExecution } from './commands';
import { damage } from './damage';
import { findLayer, type EditorDocument, type ImageLayer } from './model';
import { imageFrameLayout } from '../public-format/image-fit';

type Frame = ImageLayer['image']['frame'];
/** Placement-only edit; retains the original encoded resource and bitmap binding. */
export class UpdateImageFrameCommand implements Command {
  readonly label = 'Change image frame';
  private readonly after: Frame;
  private before?: Frame;
  private owner?: EditorDocument;
  constructor(private readonly layerId: string, frame: Frame) {
    imageFrameLayout(1, 1, frame);
    this.after = { width: frame.width, height: frame.height, fit: frame.fit };
  }
  retainedBytes(): number { return 128 + 2 * (this.layerId.length + JSON.stringify(this.after).length + JSON.stringify(this.before ?? {}).length); }
  execute(document: EditorDocument): CommandExecution {
    if (this.owner && this.owner !== document) return rejected('Image frame edit belongs to another document.');
    const layer = findLayer(document.root, this.layerId);
    if (layer?.kind !== 'image') return rejected('Image layer no longer exists.');
    if (layer.locked || layer.positionLocked) return rejected('Image placement is locked.');
    const frame = layer.image.frame;
    if (frame.width === this.after.width && frame.height === this.after.height && frame.fit === this.after.fit) return noOp();
    this.owner ??= document; this.before ??= structuredClone(frame);
    layer.image.frame = structuredClone(this.after);
    return changed(this.damage());
  }
  undo(document: EditorDocument): void {
    const layer = findLayer(document.root, this.layerId);
    if (document === this.owner && layer?.kind === 'image' && this.before) layer.image.frame = structuredClone(this.before);
  }
  redo(document: EditorDocument): void {
    const layer = findLayer(document.root, this.layerId);
    if (document === this.owner && layer?.kind === 'image') layer.image.frame = structuredClone(this.after);
  }
  damage() { return damage({ layerIds: [this.layerId], structural: true }); }
}
